module.exports = __webpack_public_path__ + "img/competition-cimb-1-2018.4148ba93.png";